<template>
  <div class="container mt-5">
    <div class="row">
      <div class="col-12">
        <b-breadcrumb :items="breadcrumbs"></b-breadcrumb>
      </div>
    </div>
    <div class="row" v-if="subCategory !== null" v-scroll-reveal="{delay: 0}">
      <div class="d-none d-md-block col-auto col-md-4">
        <img
          class="sub-category__image"
          :src="subCategory.imageUri"
          :alt="`Picture for sub-category ${subCategory.name}`"
        />
      </div>
      <div class="col-12 col-md-8">
        <h1>{{ subCategory.name }}</h1>
        <p class="sub-category__description">{{subCategory.description}}</p>
        <a class="btn btn-info" :href="subCategory.productSelectionToolUri" target="_blank">
          <span class="btn-inner--icon">
            <i class="fa fa-download mr-2"></i>
          </span>
          <span class="nav-link-inner--text">Product Selection Tool</span>
        </a>
      </div>
    </div>
    <hr class="mt-5" />
    <div
      class="row sub-category__product mt-5 mt-md-0"
      v-for="product in products"
      :key="product.id"
      v-scroll-reveal="{delay: 0}"
    >
      <div class="col-12 col-md-4">
        <h3 class="sub-category__product__name__text">{{product.name}}</h3>
      </div>
      <div class="col-12 col-md-4">
        <span class="sub-category__product__brand_text">{{product.brand}}</span>
      </div>
      <div class="col-12 col-md-4 text-md-right">
        <a
          :href="'mailto:sales@arctec.ie?Subject=Website%20enquiry: ' + product.name + '&body=Website Enquiry - Product: ' + product.name"
          rel="noopener"
          target="_blank"
          class="btn btn-primary btn-icon btn-sm"
        >
          <span class="btn-inner--icon">
            <i class="fa fa-envelope mr-2"></i>
          </span>
          <span class="nav-link-inner--text">Enquire</span>
        </a>
        <a
          :href="product.productSelectionToolUri"
          rel="noopener"
          target="_blank"
          class="btn btn-primary btn-icon btn-sm"
        >
          <span class="btn-inner--icon">
            <i class="fa fa-download mr-2"></i>
          </span>
          <span class="nav-link-inner--text">View PDF</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["ranges"]),
    rangeId() {
      return this.$route.params.rangeId;
    },
    range() {
      return this.ranges[this.rangeId];
    },
    categoryId() {
      return this.$route.params.categoryId;
    },
    category() {
      return this.range ? this.range.categories[this.categoryId] : null;
    },
    subCategoryId() {
      return this.$route.params.subCategoryId;
    },
    subCategory() {
      return this.category
        ? this.category.categories[this.subCategoryId]
        : null;
    },
    products() {
      const subCategory = this.subCategory;
      return subCategory ? subCategory.products : null;
    },
    breadcrumbs() {
      const { range, category, subCategory } = this;

      let breadcrumbs = [];

      if (range) {
        breadcrumbs.push({
          text: range.name,
          href: `#/ranges/${range.id}`
        });
      }

      if (category) {
        breadcrumbs.push({
          text: category.name,
          href: `#/ranges/${range.id}/categories/${category.id}`
        });
      }

      if (subCategory) {
        breadcrumbs.push({
          text: subCategory.name,
          active: true
        });
      }

      return breadcrumbs;
    }
  }
};
</script>

<style lang="scss">
.sub-category__image {
  font-size: 1rem;
  width: 16em;
  height: 16em;
  object-fit: cover;
}
.sub-category__description {
  font-size: 1rem;
  margin-top: 1em;
  overflow-wrap: break-word;
  word-wrap: break-word;
  hyphens: auto;
}

.sub-category__product {
  font-size: 1rem;
  height: 4em;
  display: flex;
  align-items: center;

  .sub-category__product__name__text {
    font-size: 1em;
    font-weight: bold;
    margin: 0;
  }

  .product__brand {
    width: 33%;
  }

  .product__actions {
    width: 33%;
  }
}
</style>